import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import Header from '../../components/admin/common/Header';
import { toast } from 'react-toastify';
import { setLoading } from '../../store/reducers/global-reducer';
import { connect } from 'react-redux';
import store from '../../store/index';
import axios from 'axios';
import Footer from '../../components/common/Footer';
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import Switch from 'react-input-switch';
import { Helmet } from 'react-helmet';
import SpinnerLoader from '../../components/common/SpinnerLoader';
import { NotFound } from '../../components/common/NotFound';
import { Formik } from 'formik';
import arrow_back from '../../assets/icons/arrow-back.svg'
import ProductTaxRate from '../../validation-schemas/ProductTaxRate';
import { getImageUrl } from '../../utils/getImageUrl';



class ManageProducts extends Component {
    constructor(props) {
        super(props)
        this.authInfo = store.getState().auth.authInfo;
        const { dispatch } = props;
        this.dispatch = dispatch;
        this.state = {
            reqBody: {
                count: {
                    page: 1,
                    skip: 0,
                    limit: 5
                },
                filter: {
                    type: "none",
                    is_service: false
                }
            },
            data: [],
            pendingProducts: [],
            rejectedProducts: [],
            currentTab: '',
            pagination: {},
            pendingProductsPagination: {},
            rejectedProductsPagination: {},
            productTaxRate: null,
        }
        toast.configure();

        this.addedProduct_column = [
            {
                name: 'PRODUCT IMAGE',
                selector: (row, i) => (
                    <img
                        src={getImageUrl(row.featuredImage)}
                        alt="Not selected"
                        style={{ width: "80px", height: "80px" }}
                    />
                ),
                sortable: true
            },
            {
                name: 'PRODUCT ID',
                selector: (row, i) => row.productCode,
                sortable: true
            },
            {
                name: 'PRODUCT NAME',
                selector: (row, i) => row.name,
                sortable: true
            },
            {
                name: 'BRAND',
                selector: (row, i) => row.brand.brandName,
                sortable: true
            },
            {
                name: 'CATEGORY',
                selector: (row, i) => row.category.categoryName,
                sortable: true
            },
            {
                name: 'SELLER DETAILS',
                selector: row => (
                    <>
                    <p>{row.createdBy.name || 'N/A'}</p>
                    <p title={row.createdBy.email || 'N/A'}>
                        {row.createdBy.email || 'N/A'}
                    </p>
                    </>
                ),
                sortable: true,
            },
            {
                name: 'TOTAL STOCK QUANTITY',
                selector: (row, i) => row.quantity.stock_qty,
                sortable: true
            },
            {
                name: 'SELLING QUANTITY',
                selector: (row, i) => row.quantity.selling_qty,
                sortable: true
            },
            {
                name: 'REWARDS',
                cell: (row, i) => {
                    return <>
                        <Switch
                            on={true}
                            off={false}
                            value={row.super_rewards}
                            onChange={() => this.handleRewardStatus(row.id, row.super_rewards)}
                        />
                    </>
                },
                sortable: true
            },
            {
                name: 'STATUS',
                cell: (row, i) => {
                    return <>
                        <Switch
                            on={true}
                            off={false}
                            value={row.isActive}
                            onChange={() => this.handleStatus(row.id, row.isActive)}
                        />
                    </>
                },
                sortable: true
            },
            {
                // name: 'STATUS',
                cell: (row, i) => {
                    return (
                        <>
                            <div className="d-flex justify-content-center">
                                <button
                                    type="button"
                                    className="btn custom_btn btn_yellow text-uppercase text-nowrap"
                                    onClick={() => this.props.history.push(`/admin/product-details/${row.id}`)}
                                >
                                    DETAILS
                                </button>
                            </div>
                        </>
                    );
                },
                sortable: true
            }
        ]
    }

    componentDidMount() {
        this.getProductStock(true);
    }

    getProductTaxRate = async () => {
        try {
            this.dispatch(setLoading({ loading: true }));
            const response = await axios.get('admin/getDisplayedProductTax', {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': `Bearer ${this.authInfo.token}`,
                },
            });
            if (response.data.status === true) {
                this.setState({ productTaxRate: response.data.data.product_tax_rate });
            } else {
                this.setState({ productTaxRate: null })
            }

        } catch (error) {
            console.error('Error fetching vendors:', error);
            // toast.error('Failed to fetch vendors');
        } finally {
            this.dispatch(setLoading({ loading: false }));
        }
    };

    getProductStock = async (currentStatus, currentTab) => {
        try {
            this.setState({ currentTab: currentTab })
            this.dispatch(setLoading({ loading: true }));
            const url = 'admin/getProductStock/';
            const response = await axios.get(url, {
                params: {
                    status: currentStatus
                },
                headers: {
                    'Authorization': `Bearer ${this.authInfo.token}`,
                    'Content-Type': 'application/json',
                }
            });
            if (response.data.status === true) {
                if (currentStatus === false) {
                    this.setState({ rejectedProducts: response.data.data });
                } else {
                    this.setState({ data: response.data.data });
                }
            }
        } catch (error) {
            console.error('Error fetching products:', error);
        } finally {
            this.dispatch(setLoading({ loading: false }));
        }
    }

    handleStatus = async (id, isActive) => {
        try {
            const status = !isActive;
            const updateStatusUrl = `/admin/productStatus/${id}`;
            await axios.put(updateStatusUrl, { isActive: status }, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': `Bearer ${this.authInfo.token}`
                }
            });
            if (this.state.currentTab === 'trashTab') {
                this.getProductStock(false);
            } else {
                this.getProductStock(true);
            }

        } catch (error) {
            console.error("There was an error changing the status", error);
        }
    }

    handleRewardStatus = async (id, super_rewards) => {
        try {
            const status = !super_rewards;
            console.log("status", status)
            const updateStatusUrl = `/admin/updateSuperRewards/${id}`;
            await axios.put(updateStatusUrl, { super_rewards: status }, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': `Bearer ${this.authInfo.token}`
                }
            });
            if (this.state.currentTab === 'trashTab') {
                this.getProductStock(false);
            } else {
                this.getProductStock(true);
            }

        } catch (error) {
            console.error("There was an error changing the status", error);
        }
    }

    getAddedProducts = (pagination, param, type) => {
        let reqBody = {};

        if (pagination === true) {
            reqBody = {
                count: {
                    page: param,
                    skip: (param - 1) * 5,
                    limit: 5
                },
                filter: {
                    type: "none",
                    is_service: false
                }
            };
        } else {
            reqBody = this.state.reqBody;
        }

        reqBody.filter.type = type;
        this.dispatch(setLoading({ loading: true }));
        axios.post('seller/stock/items/' + this.authInfo.id, reqBody, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': `Bearer ${this.authInfo.token}`
            }
        }).then(response => {
            if (response.data.status) {
                let types = {
                    none: 'data',
                    pending: 'pendingProducts',
                    reject: 'rejectedProducts'
                };
                let paginationNames = {
                    none: 'pagination',
                    pending: 'pendingProductsPagination',
                    reject: 'rejectedProductsPagination'
                };
                let obj = {};

                obj[types[type]] = response.data.data.items;
                obj[paginationNames[type]] = response.data.data.paginationData;
                this.setState(obj);
            }
        }).catch(error => {
            if (error.response && error.response.data.status === false) {
                toast.error(error.response.data.message);
            }
        }).finally(() => {
            setTimeout(() => {
                this.dispatch(setLoading({ loading: false }));
            }, 300);
        });
    }

    pagination = type => {
        let html = [];
        let itemLength = 0;
        let currentPage = 0;

        if (type === 'none') {
            itemLength = this.state.pagination.totalPages;
            currentPage = this.state.pagination.currentPage;
        } else if (type === 'pending') {
            itemLength = this.state.pendingProductsPagination.totalPages;
            currentPage = this.state.pendingProductsPagination.currentPage;
        } else if (type === 'reject') {
            itemLength = this.state.rejectedProductsPagination.totalPages;
            currentPage = this.state.rejectedProductsPagination.currentPage;
        }

        for (let index = 0; index < itemLength; index++) {
            let pageNumber = index + 1;
            html.push(<li key={index}><a href="#" className={`link ${currentPage === pageNumber ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); this.getAddedProducts(true, pageNumber, type); }}>{pageNumber}</a></li>);
        }
        return html;
    }

    halndleStatus = (event, productId) => {
        let reqBody = {
            is_active: event.target.checked,
            product_id: productId,
            seller_id: this.authInfo.id
        };

        this.dispatch(setLoading({ loading: true }));
        axios.put('seller/stock/items/status-update', reqBody, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': `Bearer ${this.authInfo.token}`
            }
        }).then(response => {
            if (response.data.status) {
                toast.dismiss();
                toast.success(response.data.message, { autoClose: 3000 });
                let data = [...this.state.data];
                for (let index = 0; index < data.length; index++) {
                    if (data[index].id === productId) {
                        data[index].isActive = event.target.checked === true ? false : true;
                    }
                }
                this.setState({ data });
            }
        }).catch(error => {
            toast.dismiss();
            if (error.response) {
                toast.error(error.response.data.message, { autoClose: 3000 });
            }
        }).finally(() => {
            setTimeout(() => {
                this.dispatch(setLoading({ loading: false }));
            }, 300);
        });
    }

    handleSubmit = (values, { resetForm }) => {
        const requestData = {
            ...values,
        };
        this.dispatch(setLoading({ loading: true }));
        const authInfo = JSON.parse(localStorage.getItem('authInfo'));
        axios.post('/admin/productTaxRate', requestData, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': `Bearer ${authInfo.token}`
            }
        })
            .then(response => {
                toast.dismiss();
                if (response.data.status) {
                    toast.success("Apply Successfully", { autoClose: 3000 });
                    this.getProductTaxRate();
                    resetForm();
                } else {
                    toast.error(response.data.message, { autoClose: 3000 });
                }
            })
            .catch(error => {
                toast.dismiss();
                if (error.response) {
                    toast.error(error.response.data.message, { autoClose: 3000 });
                }
            })
            .finally(() => {
                this.dispatch(setLoading({ loading: false }));
            });
    };

    handleBack = () => {
        if (window.history.length > 2 && this.props.history) {
            this.props.history.goBack();
        } else if (this.props.history) {
            this.props.history.push('/admin/dashboard');
        } else {
            window.history.back();
        }
    };

    render() {
        const { loading } = store.getState().global;
        const {
            data,
            pendingProducts,
            rejectedProducts,
            pagination,
            pendingProductsPagination,
            rejectedProductsPagination,
            productTaxRate
        } = this.state;

        return (
            <React.Fragment>
                {loading && <SpinnerLoader />}
                <div className="seller_body d-flex flex-column min-vh-100">
                    <Header />
                    
                    <main className="flex-grow-1">
                        <div className="inr_top_page_title">
                            <h2>Manage Products</h2>
                        </div>
                        
                        <Helmet>
                            <title>{"Admin - Manage Products - Pay Earth"}</title>
                        </Helmet>
                        
                        <div className="seller_dash_wrap pt-2 pb-5">
                            <div className="container-fluid">
                            <div className="bg-white rounded-3 pt-3 pb-5">
                                
                                <div className="dash_inner_wrap pb-2">
                                <div className="row align-items-center justify-content-between">
                                    <div className="col-auto dash_title">Product Management</div>
                                    <div className="col-auto mt-2 mb-2">
                                    <button
                                        type="button"
                                        className="btn custom_back_btn btn_yellow d-flex align-items-center"
                                        onClick={this.handleBack}
                                    >
                                        <img src={arrow_back} alt="back" />&nbsp;Back
                                    </button>
                                    </div>
                                </div>
                                </div>
                                
                                <nav className="orders_tabs">
                                <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                    <button className="nav-link active" id="nav-pending-orders-tab" data-bs-toggle="tab" data-bs-target="#nav-pending-orders" type="button" role="tab" aria-controls="nav-pending-orders" aria-selected="true" onClick={() => this.getProductStock(true, 'addedTab')}>Added Products</button>
                                    <button className="nav-link" id="nav-cancelled-orders-tab" data-bs-toggle="tab" data-bs-target="#nav-cancelled-orders" type="button" role="tab" aria-controls="nav-cancelled-orders" aria-selected="false" onClick={() => this.getProductStock(false, 'trashTab')}>Trash</button>
                                    <button className="nav-link" id="nav-tax-tab" data-bs-toggle="tab" data-bs-target="#nav-tax" type="button" role="tab" aria-controls="nav-tax" aria-selected="false">Tax (Stripe)</button>
                                </div>
                                </nav>
                                
                                <div className="tab-content pt-0 pb-0" id="nav-tabContent">
                                
                                <div className="tab-pane fade show active" id="nav-pending-orders" role="tabpanel" aria-labelledby="nav-pending-orders-tab">
                                    <DataTableExtensions columns={this.addedProduct_column} data={data}>
                                    <DataTable
                                        pagination
                                        noHeader
                                        highlightOnHover
                                        defaultSortField="id"
                                        defaultSortAsc={false}
                                        paginationPerPage={5}
                                        paginationRowsPerPageOptions={[5, 10, 15, 20]}
                                    />
                                    </DataTableExtensions>
                                </div>
                                
                                <div className="tab-pane fade" id="nav-cancelled-orders" role="tabpanel" aria-labelledby="nav-cancelled-orders-tab">
                                    <DataTableExtensions columns={this.addedProduct_column} data={rejectedProducts}>
                                    <DataTable
                                        pagination
                                        noHeader
                                        highlightOnHover
                                        defaultSortField="id"
                                        defaultSortAsc={false}
                                        paginationPerPage={5}
                                        paginationRowsPerPageOptions={[5, 10, 15, 20]}
                                    />
                                    </DataTableExtensions>
                                </div>
                                
                                <div className="tab-pane fade" id="nav-tax" role="tabpanel" aria-labelledby="nav-tax-tab">
                                    <div className="alert alert-info m-4">
                                        <strong>Stripe Tax</strong> replaced the old global product tax %.
                                        Set tax per category on{' '}
                                        <Link to="/admin/manage-product-categories">Product categories</Link>
                                        and enable tax on{' '}
                                        <Link to="/admin/manage-flat-fee">Platform fees &amp; currency</Link>.
                                    </div>
                                </div>
                                
                                </div>
                                
                            </div>
                            </div>
                        </div>
                    </main>   
                    <Footer />
                </div>
            </React.Fragment>
        )
    }
}

export default withRouter(connect(setLoading)(ManageProducts));
